<div class="content">
  <div class="container-fluid">
    <div class="page-title flex">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{'SMNP MIB' | translate}}
      </h1>
      <span>Last update : {{mib_LastUpdateTime}}</span>
    </div>
    <div class="page-filter border-b-radius-none" style="margin: 0 0 0 0">
      <div class="page-title sub-title">
        <h5 class="float-left">{{mib_Brand}} - {{mib_Name}}</h5>
        <div>
          <button pButton type="button" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showDialog();changeCategory()"></button>
          <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedMIB == null" class="{{Confirm_button}} update" (click)="showEditDialog();changeCategory()"></button>
          <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}}" [disabled]="selectedMIB == null" (click)="showConfirmDialog()"></button>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" [columns]="MIBMgtList_cols" [value]="MIBMgtDetailList" [rows]="10" [paginator]="true" [scrollable]="true"
        selectionMode="single" [(selection)]="selectedMIB">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td style="width: 150px" class="col-nowrap">
              <span *ngFor="let item of categoryList">
                <span *ngIf="rowData.category === item.Value">{{item.Category}}</span>
              </span>
            </td>
            <td style="width: 250px" class="col-nowrap">{{rowData.OidName}}</td>
            <td style="width: 300px" class="col-nowrap">{{rowData.Oid}}</td>
            <td style="width: 150px" class="col-nowrap" [ngSwitch]="rowData.access">
              <span *ngSwitchCase="0">Read</span>
              <span *ngSwitchCase="1">Read-Write</span>
            </td>
            <td style="width: 200px" class="col-nowrap">{{rowData.attributeName}}</td>
            <td style="width: 280px">{{rowData.desc}}</td>
            <td style="width: 120px" class="col-nowrap" [ngSwitch]="rowData.operators">
              <span *ngSwitchCase="null"></span>
              <span *ngSwitchCase="0">x</span>
              <span *ngSwitchCase="1">/</span>
              <span *ngSwitchCase="2">+</span>
              <span *ngSwitchCase="3">-</span>
            </td>
            <td style="width: 120px" class="col-nowrap">{{rowData.operands}}</td>
            <!-- <td style="width: 150px" class="col-nowrap">{{rowData.unit}}</td>
            <td style="width: 300px" class="col-nowrap">
              <span *ngFor="let item of rowData.mappingValue">
                {{ item.originalValue }} ??{{ item.displayValue }} ;
              </span>
            </td> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="MIBMgtList_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog header="{{dialogInput.UpdateType | translate}}" [(visible)]="displayDialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000" class="scrollDialog">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Category</label>
      <div class="select">
        <p-select [options]="categoryOptions" [(ngModel)]="dialogInput.category" [style]="{'width':'100%'}" [disabled]="dialogInput.UpdateType === 'Edit SNMP MIB'" (onChange)="changeCategory()"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>OID Name</label>
      <input type="text" size="50" maxlength="50" class="form-control pInputText" [(ngModel)]="dialogInput.OidName" pInputText>
    </div>
    <div class="form-group">
      <label translate>OID</label>
      <input type="text" class="form-control pInputText" [(ngModel)]="dialogInput.Oid" pInputText pattern="^(\.\d+)+$" #checkOid="ngModel">
      <p-message severity="error" text="Mib Oid is invalid." *ngIf="checkOid.invalid && (checkOid.dirty || checkOid.touched)"></p-message>
    </div>
    <div class="form-group">
      <label translate>Access</label>
      <div class="select">
        <p-select [options]="accessOptions" [(ngModel)]="dialogInput.access" [style]="{'width':'100%'}"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>Attribute Name</label>
      <div class="select">
        <p-select [options]="attributeOptions" [(ngModel)]="dialogInput.attriId" [style]="{'width':'100%'}"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>Description</label>
      <textarea [rows]="5" size="150" maxlength="150" pInputTextarea [(ngModel)]="dialogInput.desc"></textarea>
    </div>
    <div class="form-group">
      <label translate>Operators</label>
      <div class="select">
        <p-select [options]="operatorsOptions" [(ngModel)]="dialogInput.operators" [style]="{'width':'100%'}" (onChange)="operatorsOnChange($event)" appendTo="body"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>Number</label>
      <div class="select">
        <input type="number" class="form-control pInputText" [(ngModel)]="dialogInput.operands" pInputText pKeyFilter="num">
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveMIBData();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="checkOid.invalid || !dialogInput.OidName || !dialogInput.Oid || dialogInput.operands === 0"></button>
    <button type="button" pButton (click)="displayDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="deleteMIBData()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<p-toast [style]="{marginTop: '70px'}"></p-toast>
